import React from 'react';
import PropTypes from 'prop-types';
import MetadataObjectArray from '../MetadataObjectArray';
import MetadataSimpleArray from '../MetadataSimpleArray';
import Property from '../../Property';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const MetadataObject = ({ label, value, schema }) => {
  const renderValue = data => {
    const { key: propertyKey, value: propertyValue } = data;
    const currentSchema = schema?.properties?.[propertyKey];
    const propertyLabel = currentSchema?.title || propertyKey;

    if (propertyValue && Array.isArray(propertyValue)) {
      const [firstValue] = propertyValue;

      if (typeof firstValue === 'object') {
        return (
          <MetadataObjectArray
            key={propertyKey}
            label={propertyLabel}
            value={propertyValue}
            schema={currentSchema?.items ?? {}}
          />
        );
      }

      return <MetadataSimpleArray key={propertyKey} label={propertyLabel} value={propertyValue} />;
    }

    if (propertyValue && typeof propertyValue === 'object') {
      return (
        <MetadataObject
          key={propertyKey}
          label={propertyLabel}
          value={propertyValue}
          schema={currentSchema}
        />
      );
    }

    return <Property key={propertyKey} label={propertyLabel} value={propertyValue} />;
  };

  return (
    <Box pt={label ? 2 : 0} pb={label ? 2 : 1}>
      {label && (
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {label}
        </Typography>
      )}
      <Box px={1}>
        {Object.keys(value).map(propertyKey =>
          renderValue({ key: propertyKey, value: value[propertyKey] }),
        )}
      </Box>
    </Box>
  );
};

MetadataObject.propTypes = {
  label: PropTypes.string,
  value: PropTypes.object,
  schema: PropTypes.object,
};

MetadataObject.defaultProps = {
  label: undefined,
  value: {},
  schema: {},
};

export default MetadataObject;
